import { TIIndicatorPointToHighChartIndicatorPointMapper } from "../mappers/data-point/ti-indicator-point-to-highchart-indicator-point.mapper";
import { TIIndicatorDataModel } from "../models/data-point/ti-indicator-data.model";
import { IndicatorOptionModel } from "../models/drop-down-list/indicator-option.model";

export class TIIndicatorDataToKeltnerChannelSeriesBuilder {
    public static map(indicator: IndicatorOptionModel, rawIndicatorData: TIIndicatorDataModel, indicatorConfig: any, mainYAxis: string): Array<any> {
        if (!indicatorConfig || !indicatorConfig.series) {
            return [];
        }
        
        let result: Array<any> = [];

        const topSerie: any = indicatorConfig.series[0];
        const bottomSerie: any = indicatorConfig.series[1];

        
        const topSerieNeedZone = rawIndicatorData.needHighChartZone(topSerie.type);

        const builtTopSerieDataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(rawIndicatorData, indicator.value, topSerieNeedZone);
        topSerie.name = rawIndicatorData.name;
        topSerie.data = builtTopSerieDataPoints.points;

        if (topSerieNeedZone) {
            topSerie.zones = builtTopSerieDataPoints.zones;
            rawIndicatorData.zones = builtTopSerieDataPoints.zones;
            topSerie.zoneAxis = 'x';
        }

        topSerie.className = 'indicator-series ' + rawIndicatorData.getClassName();

        topSerie.yAxis = rawIndicatorData.chartAreaName + '-y-axis';
        
        topSerie.lastPrice = {
            enabled: mainYAxis != topSerie.yAxis,
            className: 'last-price-indicator-' + indicator.getClassName(),
            // color: 'rgba(0, 0, 0, 0)'
        };

        result.push(topSerie);

        if (rawIndicatorData.childIndicators?.length > 0) {
            const bottoms = rawIndicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('KELTNER_B') >= 0);
            if (bottoms) {
                const bottomSerieNeedZone = bottoms.needHighChartZone(bottomSerie.type);
        
                const builtBottomsDataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(bottoms, indicator.value, bottomSerieNeedZone);
                bottomSerie.name = bottoms.name;
                bottomSerie.data = builtBottomsDataPoints.points;
                bottomSerie.className = 'indicator-series ' + bottoms.getClassName();

                if (bottomSerieNeedZone) {
                    bottomSerie.zones = builtBottomsDataPoints.zones;
                    bottoms.zones = builtBottomsDataPoints.zones;
                    bottomSerie.zoneAxis = 'x';
                }

                bottomSerie.yAxis = rawIndicatorData.chartAreaName + '-y-axis';
                
                result.push(bottomSerie);
            }
        }

        return result;
    }
}
